export default "__VITE_ASSET__BdeCCbWg__"